<div class="">
  <div class="close_bg display-content-end" (click)="closeDialog()">
    <img class="cp" src="././assets/icon/close_icon.png">
  </div>
  <img src="{{image}}" class="w-100 p-10">
</div>